import { MoreVertOutlined } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React, { MouseEvent, useState } from 'react';
import { StyledActionButton } from './attachmentPopover.style';

interface ActionIconButtonProps {
  onDownload?: () => void;
  locale?: Record<string, any>;
}

const ActionIconButton = ({ onDownload, locale }: ActionIconButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const closeMenu = () => setAnchorEl(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDownload = () => {
    onDownload?.();
    closeMenu();
  };

  return (
    <StyledActionButton>
      <IconButton onClick={handleClick} aria-label="Action Button">
        <MoreVertOutlined fontSize="medium" />
      </IconButton>

      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={closeMenu} disableScrollLock >
        <MenuItem onClick={handleDownload}>{locale?.download}</MenuItem>
      </Menu>
    </StyledActionButton>
  );
};

export default ActionIconButton;
